import { Stack, Typography } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import { BIBlue, lightenHexColor } from "../../assets/helpers";

function TabsComponent(props) {
  const {
    tabs = [],
    setTabsValue,
    style = {},
    label = "label",
    tabValue,
    value = "value",
    setPageNr = () => {}
  } = props;

  const { selectedClientData } = useSelector((state) => state?.main);
  const clientAccentColor = selectedClientData?.AccentColor || BIBlue;

  return (
    <Stack
      direction="row"
      spacing={1}
      sx={{
        px: 1,
        py: 1,
        overflowX: "auto",
        whiteSpace: "nowrap",
        alignItems: "center",
        scrollbarWidth: "none",
        "&::-webkit-scrollbar": { display: "none" },
        ...style
      }}
    >
      {tabs.map((tab, index) => {
        const isActive = String(tabValue) === String(tab[value]);
        return (
          <Stack
            key={index}
            direction="row"
            alignItems="center"
            onClick={() => {
              setTabsValue(tab[value]);
              setPageNr(1);
            }}
            sx={{
              px: 2,
              py: 1,
              borderRadius: "30px",
              cursor: "pointer",
              backgroundColor: isActive
                ? lightenHexColor(clientAccentColor, 70)
                : "#F4F4F4",
              transition: "0.2s",
              "&:hover": {
                backgroundColor: isActive
                  ? lightenHexColor(clientAccentColor, 60)
                  : "#EAEAEA"
              }
            }}
          >
            <Typography
              sx={{
                userSelect: "none",
                fontWeight: 600,
                color: isActive ? clientAccentColor : "#333",
                fontSize: "14px"
              }}
            >
              {tab.translateLabel || tab[label]}
            </Typography>
          </Stack>
        );
      })}
    </Stack>
  );
}

export default TabsComponent;
